<template>
  <div :class="`footer-${device} ${position}`">
    <div id="footer">
      <footer
        class="footer j_a_center"
        :style="{ background: backgroundColor, color: fontcolor }"
      >
        <div class="info_basic">
          <p>
            <a
              target="_blank"
              :style="{ color: fontcolor }"
              href="https://map.baidu.com/search/%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%B7%E7%8F%A0%E5%8C%BA%E4%BF%9D%E5%88%A9%E4%B8%96%E8%B4%B8e%E5%BA%A726%E6%A5%BC2602%E5%AE%BE%E6%9E%9C%E6%B8%B8%E6%88%8F/@12609384.2,2631450.58,12z?querytype=s&wd=%E5%B9%BF%E5%B7%9E%E5%B8%82%E6%B5%B7%E7%8F%A0%E5%8C%BA%E4%BF%9D%E5%88%A9%E4%B8%96%E8%B4%B8E%E5%BA%A726%E6%A5%BC2602%E5%AE%BE%E6%9E%9C%E6%B8%B8%E6%88%8F&c=257&pn=0&device_ratio=2&da_src=shareurl"
              >网站地图</a
            >｜<span class="pointer" @click="alertMsg(1)">免责声明</span>｜<span
              @click="alertMsg(2)"
              class="pointer"
              >监督举报</span
            >
          </p>
          <!-- <p>Copyright@2018广州宾果网络科技有限公司</p> -->
          <p>COPYRIGHT © 2018 – 2022 BINGO GAMES. ALL RIGHTS RESERVED.</p>
          <p>
            <a
              href="http://beian.miit.gov.cn"
              target="_blank"
              :style="{ color: fontcolor }"
              >备案号:粤ICP备18061422号-1</a
            >
            <span class="pointer" @click="alertMsg(3)"
              >| 粤网文（2018）7180-2526号1</span
            >
          </p>
          <p class="pointer" @click="alertMsg(4)">
            增值电信业务经营许可证:粤B2-20190008
          </p>
          <p >
<a href="https://www.beian.gov.cn/portal/recordQuery?token=5539638c-c0c2-4b3a-98b7-c99cb906c843" target="_blank"><img src="https://animal-1307249104.cos.ap-guangzhou.myqcloud.com/ga.png" style="width:20px;height:20px;vertical-align: middle;float:left">粤公网安备44010502002591号</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "v_footer",
  props: {
    position: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: "#E8E9EE"
    },
    fontcolor: {
      type: String,
      default: "#282B2D"
    }
  },
  data() {
    return {};
  },
  methods: {
    alertMsg(num) {
      if (num == 1) {
        this.$alert(
          '<div style="text-indent:2em;">宾果网络科技有限公司 竭力确保所提供之资料为准确可靠，惟不保证该等资料绝对准确可靠。亦不对由于资料不准确或疏漏而引致之损失或损害承担有限公司 均不对因使用本网站资料而引致之损失或损害承担任何直接和间接责任。</div><div style="text-indent:2em;">宾果网络科技有限公司事先书面同意，不得更改、抄袭、传送、分发及/或複製本网站所载之资料；本司保留透过法律途径追究因更改、抄袭、传送、分发及/或複製本网站所载之资料而引致任何损失或法律责任。</div>',
          "免责声明",
          {
            dangerouslyUseHTMLString: true
          }
        ).catch(() => {});
      } else if (num == 2) {
        this.$alert(
          '<div style="text-indent:2em;">为保障员工的切身利益，公司设立投诉与举报热线，接受员工对公司出现的各种违规违纪行为的举报，以监督商业活动中的违法违纪行为。</div><div style="text-indent:2em;">举报电话：020-31000829</div>',
          "免责声明",
          {
            dangerouslyUseHTMLString: true
          }
        ).catch(() => {});
      } else if (num == 3) {
        this.$alert(
          '<img style="width:100%;" src="static/images/pc/wangwen.jpg" />',
          "",
          {
            dangerouslyUseHTMLString: true
          }
        ).catch(() => {});
      } else if (num == 4) {
        this.$alert(
          '<img style="width:100%;" src="static/images/pc/icp.jpg" />',
          "",
          {
            dangerouslyUseHTMLString: true
          }
        ).catch(() => {});
      }
    }
  }
};
</script>

<style lang="less" scoped="scoped">
// pc样式
.footer-pc {
  .footer {
    text-align: center;
    height: 120px;
    font-size: 14px;
    p {
      margin-bottom: 4px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.footer-mobile {
  .footer {
    text-align: center;
    height: 2rem;
    font-size: 0.1867rem;
    color: #282b2d;
    background: #e9e9e9 !important;
    p {
      margin-bottom: 0.0533rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.fixed {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}
// mobile样式
</style>

<style>
@media only screen and (max-width: 800px) {
  .el-message-box__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-message-box__wrapper .el-message-box {
    transform: scale(0.8);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v_footer.vue